import { observer } from 'mobx-react-lite';
import { useEffectOnce } from '@lib-shared/hooks';
import { useAppContext } from 'core/hooks';
import { PaymentApi } from 'core/services/api/payment/payment-api';
import { DialogWrapper } from '../components/common';
import { DialogId, useComponentContext } from '../lib';
import { useMakePaymentLogic } from '../lib/logic';
import './recurring-payment-iframe.scss';

type RecurringPaymentIframeProps = {
  onReceiveCardDetails: (event: MessageEvent) => void;
}

const RecurringPaymentIframe = observer<RecurringPaymentIframeProps>((props) => {
  const { onReceiveCardDetails } = props;

  const appContext = useAppContext();
  const context = useComponentContext();
  const { nominalAmount } = useMakePaymentLogic(false);

  useEffectOnce(() => {
    window.addEventListener("message", onReceiveCardDetails);
  });

  if (!context.showPaymentIframe) {
    return null;
  }

  const { currencyStore, customerNumber, countryName } = appContext;

  const apiService = new PaymentApi(customerNumber, countryName);
  const iframeSrc = apiService.getTokenizedPaymentUrl(currencyStore, nominalAmount);

  return <iframe id={DialogId.paymentIframe} src={iframeSrc}></iframe>;
});

export default RecurringPaymentIframe;